import * as React from 'react';

import {
  dialogueErrorButton,
  getErrorBodyVipSPSessionTimeout,
} from 'sos-eservice-common/js/config/dialogueErrorBodies';
import { Dialog } from 'sos-common/js/components/Dialog/Dialog';
import { Icon } from 'sos-common/js/components/Icon/icon';

interface ISessionExpiredDialogProps {
  isOpen: boolean;
  loginUrl: string;
  onClose: () => void;
}

export class SessionExpiredDialog extends React.Component<ISessionExpiredDialogProps> {
  doAction = (redirectUrl: string) => {
    this.props.onClose();
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  };

  mapButtons = (btn: dialogueErrorButton) => {
    return (
      <button
        type="button"
        key={btn.text + Date.now().toString()}
        onClick={(_) => this.doAction(btn.redirectUrl ?? location.host)}
        className={btn.cssClassNames}>
        {btn.text}
      </button>
    );
  };

  render(): JSX.Element {
    const { body, type, buttons } = getErrorBodyVipSPSessionTimeout(this.props.loginUrl);
    return (
      <>
        <Dialog isOpen={this.props.isOpen} onRequestClose={this.props.onClose}>
          <button type="button" className="close" onClick={this.props.onClose}>
            <Icon isAriaHidden={false} ariaLabel="Stäng" iconType="ic_close_white_24px" />
          </button>
          <React.Fragment>
            {body}
            <div className="footer">{buttons.map(this.mapButtons)}</div>
          </React.Fragment>
        </Dialog>
      </>
    );
  }
}
